import { smIconSize } from '@/constants';
import { Button } from '@nautilusbio/nb-design-system/Button';
import { CheckboxGroup } from '@nautilusbio/nb-design-system/CheckboxGroup';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import { Tooltip } from '@nautilusbio/nb-design-system/Tooltip';
import { CloudDownload } from 'lucide-react';
import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from '../styles.module.css';

export interface SamplesStatsBarProps {
  totalCount: number | null;
}

const SamplesStatsBar: FC<SamplesStatsBarProps> = ({ totalCount }) => {
  const { t } = useTranslation('studies');

  const countText = totalCount !== null ? t('sample_count', { count: totalCount }) : t('sample_count_loading');

  return (
    <Stack alignItems="center" className={styles.statsBar} justifyContent="space-between" orientation="horizontal">
      <Stack alignItems="center" gap={3} orientation="horizontal">
        <Text as="span" className={styles.sampleCount}>
          {countText}
        </Text>
        <Tooltip
          content={t('include_controls_coming_soon')}
          placement="bottom"
          trigger={
            <span className={styles.checkboxWrapperDimmed}>
              <CheckboxGroup
                data-testid="samples-include-controls"
                id="samples-include-controls"
                isDisabled
                onChange={() => {}}
                options={[{ value: 'controls', children: t('include_controls') }]}
                value={[]}
              />
            </span>
          }
        />
      </Stack>

      <Stack alignItems="center" gap={2} orientation="horizontal">
        <Tooltip
          content={t('download_selected_coming_soon')}
          placement="bottom"
          trigger={
            <Button data-testid="samples-download-selected" isDisabled size="sm" visual="unstyled">
              <CloudDownload size={smIconSize} />
              {t('download_selected')}
            </Button>
          }
        />
        <span aria-hidden="true" className={styles.statDivider} />
        <Text as="span" className={styles.statText}>
          {t('stat_studies')} | —
        </Text>
        <span aria-hidden="true" className={styles.statDivider} />
        <Text as="span" className={styles.statText}>
          {t('stat_passed_qc')} | —
        </Text>
        <span aria-hidden="true" className={styles.statDivider} />
        <Text as="span" className={styles.statText}>
          {t('stat_sample_groups')} | —
        </Text>
        <span aria-hidden="true" className={styles.statDivider} />
        <Tooltip
          content={t('qc_details_coming_soon')}
          placement="bottom"
          trigger={
            <span className={styles.checkboxWrapperDimmed}>
              <CheckboxGroup
                data-testid="samples-qc-details"
                id="samples-qc-details"
                isDisabled
                onChange={() => {}}
                options={[{ value: 'qc', children: t('qc_details') }]}
                value={[]}
              />
            </span>
          }
        />
      </Stack>
    </Stack>
  );
};

export default SamplesStatsBar;
